<template>
	<div class="about_us">
		<div class="about">
			<div class="title">
				* Bytelang感谢您的使用与关注
			</div>
			<div class="content">
				<p>本网站由Bytelang Studio开发并维护，由衷感谢前后端人员的无偿付出以及各位用户的社区推荐</p><br>
				<p>联系我们：<b>support@bytelang.com</b></p>
			</div>
		</div>
		<div class="product">
			<div class="title">
				* Bytelang Studio提供的其他工具
			</div>
			<div class="content">
				<Row>
					<Col span="6" v-for="(item,index) in product" :key="index">
						<Card class="card" style="width:100%">
							<a :href="item.link" target="_blank">
								<div style="text-align:center">
									<img class="logo" :src="item.logo">
									<h3 v-text="item.title"></h3>
									<h5 v-text="item.desc"></h5>
								</div>
							</a>
						</Card>
					</Col>
				</Row>
			</div>
		</div>
		<div class="thank">
			<div class="title">
				* 感谢以下开源项目与开源项目作者的贡献，本网站遵守各开源项目的开源协议，再次感谢以下开源项目的维护人员与开源项目的推广人员
			</div>
			<div class="content">
				<Row>
					<Col span="6" v-for="(item,index) in opensource" :key="index">
						<Card class="card" style="width:100%;">
							<a :href="item.link" target="_blank">
								<div style="text-align:center">
									<img class="logo" :src="item.logo">
									<h3 v-text="item.title"></h3>
									<h5 v-text="item.desc"></h5>
								</div>
							</a>
						</Card>
					</Col>
				</Row>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "about_us",
		data(){
			return {
				product: [
					{
						title: "Kplayer",
						desc: "用于提供服务端视频媒体资源无缝RTMP协议推流直播工具",
						logo: "https://kplayer.bytelang.cn/logo.png",
						link: "https://kplayer.bytelang.cn",
					}
				],
				opensource: [
					{
						title: "Kubernetes",
						logo: "https://www.kubernetes.org.cn/wp-content/themes/dux/img/thumbnail.png",
						link: "https://www.kubernetes.org.cn/",
					},
					{
						title: "Docker",
						logo: "https://www.docker.com/sites/default/files/d8/styles/role_icon/public/2019-07/vertical-logo-monochromatic.png?itok=erja9lKc",
						link: "https://www.docker.com/",
					},
					{
						title: "Rancher",
						logo: "https://rancher.com/imgs/rancher-logo-only-color.svg",
						link: "https://rancher.com/",
					},
					{
						title: "VueJS",
						logo: "https://cn.vuejs.org/images/logo.png",
						link: "https://cn.vuejs.org/",
					},
					{
						title: "Rabbitmq",
						logo: "https://simg.open-open.com/show/03379414b3572debc448e04f087c61aa.jpg",
						link: "https://www.rabbitmq.com/",
					},
					{
						title: "GitLab",
						logo: "https://about.gitlab.com/images/new_logo/A.jpg",
						link: "https://about.gitlab.com/",
					},
				],
			};
		}
	}
</script>

<style scoped lang="less">
	@import "../../../src/theme/default";
	
	.about_us {
		padding: 20px 200px;
		
		.title {
			font-weight: 900;
			font-size: 15px;
			margin-bottom: 20px;
			padding-top: 20px;
		}
		
		.content {
			margin-top: 10px;
			margin-bottom: 10px;
		}
		
		.about {
			border-bottom: 1px solid #eee;
			padding: 10px 0;
		}
		
		.product {
			border-bottom: 1px solid #eee;
			padding: 10px 0;
			
			.logo {
				image {
					width: 100%;
					height: 100%;
				}
				
				width: 130px;
				height: 130px;
				border-radius: 50%
			}
		}
		
		.logo {
			image {
				width: 100%;
				height: 100%;
			}
			
			height: 130px;
			max-width: 100%;
		}
		
		.card {
			a {
				color: #515a6e;
			}
			
			cursor: pointer;
		}
		
		/deep/ .ivu-col {
			padding: 10px;
		}
	}
</style>